import {Injectable, Inject} from 'ng-metadata/core';
import {LoginHelpData} from './loginHelpConfigurationData.interface';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {getAZLangages, getVid} from "../../../appConfig/appConfigForward";

@Injectable()
export class LoginHelpService {
    private _displaySigninHelp: boolean = false;
    private _loginHelpData: LoginHelpData;

    constructor( private mappingTablesCache: MappingTablesCache,
                 @Inject('$translate') private $translate: ng.translate.ITranslateService,
                 private configurationUtil : ConfigurationUtil ) {

        this.getHelpCodeData().then(
            ( response ) => {
                // success
                this.setHelpData( response );
            },
            ( response ) => {
                // error
                this._displaySigninHelp = false;
            }
        );
    }

    private substituteUrlParams( url: string) : string {
        let urlParams = {
            lang: this.$translate.use(),
            vid: getVid()
        }
        return url.replace(/\{([^}]+)\}/g, function(match, paramName) {
            return urlParams[paramName] || match;
        });
    }
    // Assembles the required help data from MT and CT
    private setHelpData( response ) {
        let moreInfo = response['nui.login.help'];
        let helpDescription = response['nui.help.description'];

        if ( moreInfo === 'nui.login.help' ) {
            moreInfo = '';
        }

        if ( helpDescription === 'nui.help.description' ) {
            helpDescription = '';
        }

        let links = [];
        for ( let i = 0; i < 4; i++ ) {
            let linkIndex = i + 1;
            let linkConfig = this.mappingTablesCache.findByProperties( 'User Login Links', { source1: 'login.link' + linkIndex } );
            if ( linkConfig.length > 0 ) {
                let url = (this.configurationUtil.isSuprima()) ? linkConfig[0].source2 : linkConfig[0].target;
                if (!url) {
                    continue;
                }
                url = this.substituteUrlParams(url);
                links.push( { label: 'nui.help.login.link' + linkIndex, linkURL: url } );
            }
        }

        // Determine if to show help section
        if ( ( !moreInfo ) ||
             ( ( !helpDescription ) && ( !links || links.length === 0 ) ) ) {
            // Do not display help section if:
            // No more info label OR No links and description
            this._displaySigninHelp = false;
        }
        else {
             this._displaySigninHelp = true;
        }

        // Set the help data retrieved
        this._loginHelpData = {
            moreInfo: moreInfo,
            description: helpDescription,
            links: links
        };
    }

    get displaySigninHelp() {
        return this._displaySigninHelp;
    }

    get loginHelpData() {
        return this._loginHelpData;
    }

    private getHelpCodeData() {
        let moreInfoLabel = '';
        let helpDescription = '';

        return this.$translate( [ 'nui.login.help', 'nui.help.description' ] );
    }
}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/loginHelp/loginHelp.service.ts